<template>
    <SettingsPage title="Preise exportieren">
        <div id="save-list">
            <PriceList
                v-model="PriceToExport"
                :loading="loading"
                :saved-prices="ExportList"
                @delete="PriceToDelete => deleteExport(PriceToDelete)"
            >
                <select
                    v-if="PriceToExport && PriceToExport.pharmacyGroupId"
                    v-model="selectedPharmacy"
                >
                    <option v-for="(option, index) in pharmacies" :key="index" :value="option">
                        {{ option.name }}
                    </option>
                </select>
            </PriceList>
        </div>
        <div id="export">
            <div id="export-mail">
                <h6>Preise als E-Mail Anhang an eine Adresse schicken</h6>
                <b-input id="email" v-model="email" placeholder="E-Mail Adresse" type="email" />
                <b-form-textarea
                    id="email-text"
                    v-model="emailText"
                    placeholder="Text in der E-Mail (optional)"
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
                <b-button-group class="export-interaction">
                    <SmartButton
                        variant="primary"
                        :disabled="!email || !PriceToExport"
                        @click="sendCSVMail"
                    >
                        <b-badge>CSV</b-badge>
                        Datei senden
                    </SmartButton>
                    <SmartButton
                        variant="primary"
                        :disabled="
                            !email ||
                                !PriceToExport ||
                                (PriceToExport.pharmacyGroupId && !selectedPharmacy)
                        "
                        @click="sendPDFMail"
                    >
                        <b-badge>PDF</b-badge>
                        Liste senden
                    </SmartButton>
                </b-button-group>
            </div>
            <div id="export-download">
                <h6>Preise auf diesen Rechner herunterladen</h6>

                <b-button-group class="export-interaction">
                    <b-button
                        variant="primary"
                        :disabled="!PriceToExport"
                        @click="getCSVDownload()"
                    >
                        <b-badge>CSV</b-badge>
                        Datei herunterladen
                    </b-button>
                    <b-button
                        variant="primary"
                        :disabled="
                            !PriceToExport || (PriceToExport.pharmacyGroupId && !selectedPharmacy)
                        "
                        @click="getPDFDownload()"
                    >
                        <b-badge>PDF</b-badge>
                        Liste herunterladen
                    </b-button>
                </b-button-group>
            </div>
        </div>
    </SettingsPage>
</template>

<script>
import ExportPrices from "@/store/api/data/ExportPrices";
import PriceList from "../../components/widgets/PriceList";
import SettingsPage from "./SettingsPage";
import SmartButton from "@/views/shared/widgets/SmartButton";

export default {
    name: "ExportVue",
    components: { SmartButton, SettingsPage, PriceList },
    data() {
        return {
            email: this.$store.state.user.user_obj.email,
            emailText: null,
            PriceToExport: null,
            selectedPharmacy: null,
            loading: true
        };
    },
    computed: {
        pharmacies() {
            return this.$store.state.data.pharmacies.filter(
                pharmacy =>
                    this.PriceToExport &&
                    this.PriceToExport.pharmacyGroupId &&
                    pharmacy.pharmacyGroupId === this.PriceToExport.pharmacyGroupId
            );
        },
        currentPharmacyId() {
            // could be waaay easier with
            // this.PriceToExport?.pharmacyId || this.selectedPharmacy?.pharmacyId
            if (this.PriceToExport && this.PriceToExport.pharmacyId) {
                return this.PriceToExport.pharmacyId;
            } else {
                if (this.selectedPharmacy) {
                    return this.selectedPharmacy.id;
                } else {
                    return null;
                }
            }
        },
        ExportList() {
            return this.$store.state.exportPrices.exportList.map(savedPrices => ({
                ...savedPrices,
                save_id: savedPrices.id,
                // name comes from pharmacyId or pharmacyGroupId
                name: savedPrices.pharmacyGroupId
                    ? (
                          this.$store.state.data.pharmacyGroup.find(
                              item => item.id === savedPrices.pharmacyGroupId
                          ) || { name: "Unbekannte Apothekengruppe" }
                      ).name
                    : (
                          this.$store.state.data.pharmacies.find(
                              item => item.id === savedPrices.pharmacyId
                          ) || { name: "Unbekannte Apotheke" }
                      ).name
            }));
        }
    },
    created() {
        this.$store.dispatch("loadExports").finally(() => {
            this.loading = false;
        });
    },
    methods: {
        async sendCSVMail() {
            ExportPrices.sendCSVMailExport(
                this.PriceToExport.save_id,
                this.email,
                this.emailText
            ).then(() => {
                this.success = "E-Mail gesendet";
            });
        },
        async sendPDFMail() {
            ExportPrices.sendPDFMailExport(
                this.PriceToExport.save_id,
                this.email,
                this.emailText,
                this.currentPharmacyId
            ).then(console.log);
        },
        getCSVDownload() {
            ExportPrices.getCSVDownloadExport(this.PriceToExport.save_id);
        },
        getPDFDownload() {
            ExportPrices.getPDFDownloadExport(this.PriceToExport.save_id, this.currentPharmacyId);
        },
        deleteExport(PriceToExport) {
            this.$store.dispatch("deleteExport", PriceToExport.save_id);
        }
    }
};
</script>

<style scoped lang="scss">
#export {
    display: flex;
    justify-content: space-around;
}
#export > * {
    margin: 16px;
}
.export-interaction,
#email,
#email-text {
    width: 100%;
    margin-top: 12px;
}
</style>
